import React from 'react';
import LogoDoang from './../images/LogoDoang.svg';

const Navbar = (props) => {
    const HandlerClick = (event) => {
        event.preventDefault(); // Prevents the default behavior of the link
        const href = event.target.getAttribute('href'); // Get the href attribute of the clicked link
        console.log(href);
        const element = document.querySelector(href); // Get the element that the href refers to
        const yPosition = element.getBoundingClientRect().top + window.pageYOffset; // Get the y position relative to the viewport
        window.scrollTo({
            top: yPosition, // Add the offsetTop to the current scroll position
            behavior: 'smooth' // Smooth scroll
        });
    }
    return (
        <nav className='bg-gradient-to-b from-[#0E0E0E]/20 to-transparent fixed top-0 left-0 w-full z-[9999]'>
            <ul className='flex justify-between items-center px-16 pb-5 pt-3'>
                <li className='h-[80%] opacity-90'><img src={LogoDoang} width={35} alt='logo'></img></li>
                <li className=''>
                    <ul className='flex flex-row'>
                        <li className='text-white text-2xl mx-4 opacity-30 hover:opacity-100 cursor-pointer font-bold'><a href='#parent' onClick={HandlerClick}>Home</a></li>
                        <li className='text-white text-2xl mx-4 opacity-30 hover:opacity-100 cursor-pointer font-bold'><a href='#Profile' onClick={HandlerClick}>Profile</a></li>
                        <li className='text-white text-2xl mx-4 opacity-30 hover:opacity-100 cursor-pointer font-bold'><a href='#Experience' onClick={HandlerClick}>Experience</a></li>
                        <li className='text-white text-2xl mx-4 opacity-30 hover:opacity-100 cursor-pointer font-bold'><a href='#Project' onClick={HandlerClick}>Project</a></li>
                        <li className='text-white text-2xl mx-4 opacity-30 hover:opacity-100 cursor-pointer font-bold'><a href='#Skill' onClick={HandlerClick}>Skill</a></li>
                    </ul>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;
